import React from 'react'
import { IconS24Pen24, IconS24Plus24 } from '@is24/cosma-ui-icons'
import { AttachmentDataWithRequiredAttachment } from '../../../../../../../../../../@types/types'
import { CircularActionButton } from './CircularActionButton'
import styles from './CarouselActionButtons.module.css'

interface CarouselActionButtonsProps {
  currentAttachment: AttachmentDataWithRequiredAttachment
  dropzoneId: string
  onEditClick: (attachment: AttachmentDataWithRequiredAttachment) => void
  onAddClick: () => void
}

export const CarouselActionButtons: React.FC<CarouselActionButtonsProps> = ({
  currentAttachment,
  dropzoneId,
  onEditClick,
  onAddClick,
}) => {
  const handleEditClick = (e: React.MouseEvent) => {
    e.preventDefault()
    e.stopPropagation()
    onEditClick(currentAttachment)
  }

  const handleAddClick = () => {
    onAddClick()
  }

  return (
    <div className={styles.buttonsContainer}>
      <CircularActionButton
        onClick={handleEditClick}
        icon={<IconS24Pen24 width={16} height={16} />}
        ariaLabel='Edit picture'
      />
      <CircularActionButton
        id={dropzoneId}
        onClick={handleAddClick}
        icon={<IconS24Plus24 width={16} height={16} />}
        ariaLabel='Add picture'
      />
    </div>
  )
}
